import pheader from "../images/p-header.png";
import cornerImg from "../images/doubts.png";
import section2 from "../images/Section2.png";
import doctor1 from "../images/doctor1.png";
import doctor2 from "../images/doctor2.png";
import doctor3 from "../images/doctor3.png";
import doctor4 from "../images/doctor4.png";
import planImage from "../images/vegitable.png";
import Testimonial from "../components/testimonial";
import Form from "../components/form";

// ======Section3: Experts========
const experts = [
  {
    name: "Dr. Sarah Johnson",
    role: "Specialist in fitness training",
    img: doctor1,
  },
  {
    name: "Dr. Ayesha",
    role: "Specialist in fitness training",
    img: doctor2,
  },
  {
    name: "Dr. Michael",
    role: "Specialist in fitness training",
    img: doctor3,
  },
  {
    name: "Dr. Sarah Johnson",
    role: "Specialist in fitness training",
    img: doctor4,
  },
];

// ======Section5: Plans========

const plans = [
  {
    id: "basic",
    name: "Basic Plan",
    price: "$99",
    priceNoteClass: "text-base text[18px] text-[#4B5563] ml-1",
    wrapperClass:
      "bg-white rounded border border-slate-100 shadow-[0_10px_25px_rgba(15,23,42,0.06)] flex flex-col justify-between md:min-h-[420px] font-poppins",
    innerClass: "pl-[1rem] pt-10 pb-8",
    buttonWrapperClass: "px-8 pb-8 font-poppins",
    buttonClass:
      "w-full rounded-md bg-[#56C7D5] py-3 text-sm font-medium text-white shadow-md hover:opacity-90 transition font-poppins mt-8",
    featured: false,
    featuresTextClass: "space-y-3 text-[15px] text-[#374151] font-poppins",
    features: [
      "100,00+ treatments",
      "Personalized diet & exercise guides",
      "Doctor available on-demand",
      "Private & secure support",
    ],
  },
  {
    id: "standard",
    name: "Standard Plan",
    price: "$149",
    priceNoteClass: "text-base text-[#4B5563] ml-1",
    wrapperClass:
      "relative bg-white rounded border-[2px] border-[#35C3D9] shadow-[0_16px_35px_rgba(15,23,42,0.12)] flex flex-col justify-between md:min-h-[460px] md:-translate-y-4 font-poppins",
    innerClass: "pl-[1rem] pt-12 pb-10 font-poppins",
    buttonWrapperClass: "px-8 pb-[3rem] font-poppins",
    buttonClass:
      "w-full rounded-md bg-[#56C7D5] py-3 text-sm font-semibold text-white shadow-md hover:opacity-90 transition",
    featured: true,
    featuresTextClass: "space-y-3 text-[15px] text-[#374151]",
    features: [
      "Everything in Self-Managed",
      "Monthly doctor review included",
      "Ongoing motivation & progress adjustments",
      "Priority support",
    ],
  },
  {
    id: "premium",
    name: "Premium Plan",
    price: "$249",
    priceNoteClass: "text-base text-[#4B5563] ml-1",
    wrapperClass:
      "bg-white rounded border border-slate-100 shadow-[0_10px_25px_rgba(15,23,42,0.06)] flex flex-col justify-between md:min-h-[420px] font-poppins",
    innerClass: "pl-[1rem] pt-10 pb-8",
    buttonWrapperClass: "px-5 pb-8 font-poppins",
    buttonClass:
      "w-full rounded-md bg-[#56C7D5] py-3 text-sm font-semibold text-white shadow-md hover:opacity-90 transition",
    featured: false,
    featuresTextClass: "space-y-3 text-[15px] text-[#374151] font-poppins",
    features: [
      "Everything in Standard Plan",
      "Unlimited doctor consultations",
      "Personalized meal plans updated weekly",
      "24/7 chat & video support",
    ],
  },
];

const pricing = () => {
  return (
    <>
      {/* ========== HERO / HEADER ========== */}
      <section className="bg-white font-poppins">
        <img
          src={cornerImg}
          alt="dots"
          className="absolute left-0 top-[75px] w-16 sm:w-20 opacity-80 pointer-events-none select-none"
        />
        <div className="max-w-7xl mx-auto px-6 lg:px-0 py-16 relative">

          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14 font-poppins">
            <div className="w-full md:w-7/12 font-poppins">
              <h1 className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[39px] sm:text-[30px] md:text-[38px] lg:text-[55px] mb-5">
                Affordable treatments
                <br />
                with Excellence in care.
              </h1>

              <p className="text-[16px] leading-relaxed text-[#556987] max-w-2xl">
                Slimming Doctor is one of the most affordable weight loss
                clinics in London. Your treatment programme which includes
                regular consultations with the doctor, meal plan and
                prescription-only medications (appetite suppressants) costs less
                than a price of coffee with us. It could as low as £2.38 per
                day!!! Slimming Doctor does not tie you in a contract and you
                are free to leave the programme at any time. There are no other
                hidden or surprise costs – and that&apos;s our promise to you.
              </p>
            </div>

            <div className="w-full md:w-5/12 flex justify-center">
              <img
                src={pheader}
                alt="Treatment"
                className="w-full rounded object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* =============Section2================== */}
      <img
        src={section2}
        alt="Section Image"
        className="w-full h-auto object-cover"
      />

      {/* ====================Section3: Experts========================== */}
      <section className="py-16 md:py-20 font-poppins">
        <div className="max-w-7xl mx-auto px-6 lg:px-0">
          <div className="text-center font-poppins">
            <h2 className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[55px] mb-5">
              Meet our Expert
            </h2>
            <p className="mt-3 text-[16px] text-[#556987] leading-[30px] mx-auto">
              Dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
              aspernatur aut odit aut fugit.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 font-poppins">
            {experts.map((item) => (
              <div key={item.name} className="flex flex-col font-poppins">
                <div className="w-full">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-full object-cover rounded"
                  />
                </div>

                <div className="mt-4 font-poppins">
                  <h3 className="text-[20px] font-semibold text-[#2A3342]">
                    {item.name}
                  </h3>
                  <p className="mt-1 text-[16px] text-[#556987]">
                    {item.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==============Section4======================== */}

      <section className="bg-[#FAFAFA] py-16 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-2 
                  grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* Left Text */}
          <div className="font-poppins max-w-xl">
            <h2
              className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[39px] sm:text-[30px] md:text-[38px] lg:text-[47px] mb-5"
              style={{ lineHeight: "60px" }}
            >
              Personalised weight loss <br />
              plans that work for you.
            </h2>

            <p className="mt-6 text-[#556987] text-[16px] leading-relaxed">
              Our weight loss treatment is a bespoke program based on your
              individual requirements. Here at Slimming Doctor, we understand
              your Journey. Our specialist doctor is here to help achieve your
              healthier weight with a supportive approach which will work for you.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
              src={planImage}
              alt="Weight Loss Plan"
              className="rounded w-full object-cover"
            />
          </div>
        </div>
      </section>


      {/* ============Section5: Pricing Plans================= */}
      <section className="bg-white py-20 font-poppins">
        <div className="max-w-7xl mx-auto px-2 font-poppins">

          <h2 className="text-center font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[55px] mb-24">
            Choose Your Weight Loss Plan
          </h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-[1rem]">
            {plans.map((plan) => (
              <PlanCard key={plan.id} {...plan} />
            ))}
          </div>
        </div>
      </section>

      <Testimonial />
      <Form />
    </>
  );
};

export default pricing;

// ========== Reusable Components ========== //

const PlanCard = ({
  name,
  price,
  priceNoteClass,
  wrapperClass,
  innerClass,
  buttonWrapperClass,
  buttonClass,
  featured,
  featuresTextClass,
  features,
}) => {
  return (
    <div
      className={wrapperClass}
      style={featured ? { marginBottom: "-32px" } : undefined}
    >
      {featured && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 font-poppins">
          <span className="px-4 py-1 text-[12px] font-semibold text-white bg-[#56C7D5] rounded-full shadow-md">
            Most Popular
          </span>
        </div>
      )}

      <div className={innerClass}>
        <h3 className="text-center text-[24px] font-bold text-[#111827] mb-2 mt-2">
          {name}
        </h3>

        <div className="text-center mb-6">
          <span className="text-[48px] font-bold text-[#111827]">{price}</span>
          <span className={priceNoteClass}>/month</span>
        </div>

        <ul className={featuresTextClass}>
          {features.map((feature) => (
            <PlanFeature key={feature}>{feature}</PlanFeature>
          ))}
        </ul>
      </div>

      <div className={buttonWrapperClass}>
        <button type="button" className={buttonClass}>
          Choose Plan
        </button>
      </div>
    </div>
  );
};

const PlanFeature = ({ children }) => (
  <li className="flex items-start gap-2">
    <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#56C7D5]">
      <span className="text-xs text-white">✓</span>
    </span>
    <span>{children}</span>
  </li>
);